import { render, staticRenderFns } from "./kiyaku.vue?vue&type=template&id=6a544936&scoped=true&"
import script from "./kiyaku.vue?vue&type=script&lang=ts&"
export * from "./kiyaku.vue?vue&type=script&lang=ts&"
import style0 from "./kiyaku.vue?vue&type=style&index=0&id=6a544936&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a544936",
  null
  
)

export default component.exports